export const S3_URL = process.env.REACT_APP_IMAGE_URL;
